// @ts-strict-ignore
import { Injectable, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs';
import { LMGenAISummarizeDialogComponent } from '@modal/lm-genai-summarize-dialog.component';
import { LMModel } from '@form/model';
import { LMPrintPdfInfo } from '@app/components';
import {LMDialogButtonKey, LMGlobalUtilService, LMUniqueIdService} from '@app/utils';
import { LMModalDialogWrapperRef, LMModalWrapperService } from '@app/services';

export enum GenAISummarizeDialogStatus {
  RESPONSE_CANCEL = 0,
  RESPONSE_OK,
  RESPONSE_COPY,
}

export interface GenAISummarizeDialogResult {
  status: GenAISummarizeDialogStatus;
  generated: string;
  fieldId?: string;
  dataView?: LMDataView;
  model?: LMModel;
}

@Injectable()
export class LMGenAISummarizeDialogService {

  constructor(
    private lmUniqueIdService: LMUniqueIdService,
    private lmModalWrapperService: LMModalWrapperService,
    private lmGlobalUtilService: LMGlobalUtilService,
  ) {}

  /**
   * Prompt GenAI Summarize dialog
   * @param viewContainerRef
   *
   * @return Observable<any>
   */
  public promptGenAISummarizeDialog(placeholder: ViewContainerRef, settings: LMGenAISummarizeInfo) : Observable<any> {
    const prompt: Observable<GenAISummarizeDialogResult> = new Observable<GenAISummarizeDialogResult> (observer => {
      let genAIComponent: LMGenAISummarizeDialogComponent;
      let dialog: LMModalDialogWrapperRef<any> = undefined;

      const attributes: SohoAttributesArray = [ {
        name: 'data-automation-id',
        value: 'lm-gen-ai-modal'
      } ];

      const sohoModalOptions: SohoModalOptions = {
        fullsize: 'responsive',
        frameHeight: 1525,
        attributes
      };

      const dialogId = 'GenAISummarize';
      const buttons = [
        {
          id: this.lmUniqueIdService.uniqueId([ dialogId, LMDialogButtonKey.COPY ]),
          default: true,
          text: Soho.Locale.translate(LMDialogButtonKey.COPYANDCLOSE),
          click: (e, modal) => {
            // (genAIComponent.editor as any).editor.getCurrentElement().select();
            // document.execCommand('copy');
            // (genAIComponent.editor as any).editor.getCurrentElement().setSelectionRange(0, 99999);
            // navigator.clipboard.writeText((genAIComponent.editor as any).editor.getCurrentElement().value);
            const selBox = document.createElement('textarea');
            selBox.style.position = 'fixed';
            selBox.style.left = '0';
            selBox.style.top = '0';
            selBox.style.opacity = '0';
            selBox.value = genAIComponent.summaryField.value;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            document.execCommand('copy');
            document.body.removeChild(selBox);

            this.lmGlobalUtilService.displayToastMessage('', Soho.Locale.translate('SummaryCopied'));

            dialog.close(<GenAISummarizeDialogResult> {
              status: GenAISummarizeDialogStatus.RESPONSE_COPY
            });
          }
        }
      ];

      dialog = this.lmModalWrapperService
        .modal(LMGenAISummarizeDialogComponent, sohoModalOptions)
        .showCloseBtn(true)
        .buttons(buttons)
        .title(Soho.Locale.translate('GenerateAISummarizeDialogTitle'))
        .icon('insights-smart-panel')
        .iconClass('info')
        .isAlert(false)
        .open()
        .apply((genAIForm: LMGenAISummarizeDialogComponent) => {
          genAIComponent = genAIForm;
          genAIComponent.dataView = settings.dataView;
          genAIComponent.resource = settings.resource;
          genAIComponent.panelSpecs = settings.panelSpecs;
          genAIComponent.selectedTabIndex = settings.selectedTabIndex;
          genAIComponent.model = settings.model;
          genAIComponent.formSpec = settings.formSpec;

          genAIComponent.fromList = settings.fromList;
          genAIComponent.fromResource = settings.fromResource;
          genAIComponent.actionReference = settings.actionReference;
          genAIComponent.name = settings.name;
          genAIComponent.pdfType = settings.pdfType;
          genAIComponent.includeSearchForm = settings.includeSearchForm;
          genAIComponent.cubeOverrides = settings.cubeOverrides;
          genAIComponent.cubeOptions = settings.cubeOptions;
          genAIComponent.userFolder = settings.userFolder;
          genAIComponent.dataViewSet = settings.dataViewSet;
          genAIComponent.selectedRows = settings.selectedRows;
          genAIComponent.filterFields = settings.filterFields;
          genAIComponent.selectRequestData = settings.selectRequestData;
        })
        .afterClose(result => {
          observer.next(result);
          observer.complete();
        });
    });
    return prompt;
  }

}
export interface LMGenAISummarizeInfo extends LMPrintPdfInfo {
  selectedTabIndex?: number
  selectedPanelName?: string
  listParams?: LMPaneListParams
  includeSearchForm?: boolean,
  panelSpecs?: Array<LMCompositePanelSpec>,
  formSpec?: LMBusFormSpec;
  model?: LMModel;
}
